import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/app';

// design/tokens.css is the only output of design/ that enters the bundle, and
// it goes first: global.css and every feature stylesheet consume its
// variables. See design/README.md.
import '../design/tokens.css';
import './global/styles/global.css';

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
